import type { ReactNode } from 'react';

export const symbol_power: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M442-180h76v-82l142-156v-191H300v191l142 155.7v82.3Zm-60 30v-88L256-377q-7.65-7.86-11.83-18.21Q240-405.57 240-417v-192q0-24.75 17.63-42.38Q275.25-669 300-669h72l-30 30v-171q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v141h156v-141q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v171l-30-30h72q24.75 0 42.38 17.62Q720-633.75 720-609v192q0 11.43-4.17 21.79Q711.65-384.86 704-377L578-238v88q0 12.75-8.62 21.37Q560.75-120 548-120H412q-12.75 0-21.37-8.63Q382-137.25 382-150Zm98-245Z"
		/>
	</svg>
);
